import { Button, Flex, Popup, Text } from '@approvalmax/ui/src/components';
import { memo } from 'react';

import { usePrintPreviewNotificationPopup } from './PrintPreviewNotificationPopup.hooks';
import { messages } from './PrintPreviewNotificationPopup.messages';

export const PrintPreviewNotificationPopup = memo(() => {
    const { isOpen, handleClose } = usePrintPreviewNotificationPopup();

    return (
        <Popup size='xsmall' open={isOpen} closable>
            <Popup.Header />

            <Popup.Body spacing='32 64'>
                <Flex spacing='24' justifyContent='center'>
                    <Text font='headline' fontSize='small' textAlign='center'>
                        {messages.description}
                    </Text>

                    <Button color='blue80' size='large' onClick={handleClose}>
                        {messages.buttonClose}
                    </Button>
                </Flex>
            </Popup.Body>
        </Popup>
    );
});

PrintPreviewNotificationPopup.displayName = 'PrintPreviewNotificationPopup';
